import { render, staticRenderFns } from "./ProjectStart.vue?vue&type=template&id=3d4211c1&scoped=true&"
import script from "./ProjectStart.vue?vue&type=script&lang=js&"
export * from "./ProjectStart.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStart.vue?vue&type=style&index=0&id=3d4211c1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4211c1",
  null
  
)

export default component.exports